/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkContainertype } from '../models/work-containertype';
import { WorkContainertypeConfigEnum } from '../models/work-containertype-config-enum';
import { WorkCreateContainertypeDto } from '../models/work-create-containertype-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkProjectAdvisorSourceEnum } from '../models/work-project-advisor-source-enum';
import { WorkUpdateContainertypeDto } from '../models/work-update-containertype-dto';

@Injectable({ providedIn: 'root' })
export class WorkContainertypesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `containertypesV2ControllerGetAllDropdownOptions()` */
  static readonly ContainertypesV2ControllerGetAllDropdownOptionsPath = '/v2/containertypes/dropdown-options';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `containertypesV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  containertypesV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContainertypesV2Service.ContainertypesV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `containertypesV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  containertypesV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.containertypesV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `containertypesV2ControllerFindAll()` */
  static readonly ContainertypesV2ControllerFindAllPath = '/v2/containertypes';

  /**
   * Required permissions: containertypes:read, containertypes:admin, projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `containertypesV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  containertypesV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkContainertype>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContainertypesV2Service.ContainertypesV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkContainertype>>;
      })
    );
  }

  /**
   * Required permissions: containertypes:read, containertypes:admin, projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `containertypesV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  containertypesV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkContainertype>> {
    return this.containertypesV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkContainertype>>): Array<WorkContainertype> => r.body)
    );
  }

  /** Path part for operation `containertypesV2ControllerCreate()` */
  static readonly ContainertypesV2ControllerCreatePath = '/v2/containertypes';

  /**
   * Required permissions: containertypes:create, containertypes:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `containertypesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  containertypesV2ControllerCreate$Response(
    params: {
      body: WorkCreateContainertypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContainertype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContainertypesV2Service.ContainertypesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContainertype>;
      })
    );
  }

  /**
   * Required permissions: containertypes:create, containertypes:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `containertypesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  containertypesV2ControllerCreate(
    params: {
      body: WorkCreateContainertypeDto
    },
    context?: HttpContext
  ): Observable<WorkContainertype> {
    return this.containertypesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContainertype>): WorkContainertype => r.body)
    );
  }

  /** Path part for operation `containertypesV2ControllerFindOneById()` */
  static readonly ContainertypesV2ControllerFindOneByIdPath = '/v2/containertypes/{id}';

  /**
   * Required permissions: containertypes:read, containertypes:admin, projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `containertypesV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  containertypesV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContainertype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContainertypesV2Service.ContainertypesV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContainertype>;
      })
    );
  }

  /**
   * Required permissions: containertypes:read, containertypes:admin, projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `containertypesV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  containertypesV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkContainertype> {
    return this.containertypesV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContainertype>): WorkContainertype => r.body)
    );
  }

  /** Path part for operation `containertypesV2ControllerDelete()` */
  static readonly ContainertypesV2ControllerDeletePath = '/v2/containertypes/{id}';

  /**
   * Required permissions: containertypes:delete, containertypes:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `containertypesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  containertypesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContainertypesV2Service.ContainertypesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: containertypes:delete, containertypes:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `containertypesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  containertypesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.containertypesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `containertypesV2ControllerUpdate()` */
  static readonly ContainertypesV2ControllerUpdatePath = '/v2/containertypes/{id}';

  /**
   * Required permissions: containertypes:update, containertypes:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `containertypesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  containertypesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateContainertypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContainertype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContainertypesV2Service.ContainertypesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContainertype>;
      })
    );
  }

  /**
   * Required permissions: containertypes:update, containertypes:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `containertypesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  containertypesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateContainertypeDto
    },
    context?: HttpContext
  ): Observable<WorkContainertype> {
    return this.containertypesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContainertype>): WorkContainertype => r.body)
    );
  }

  /** Path part for operation `containertypesV2ControllerEnumDummyEndpoint()` */
  static readonly ContainertypesV2ControllerEnumDummyEndpointPath = '/v2/containertypes/enum/{containertypeConfigEnum}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `containertypesV2ControllerEnumDummyEndpoint()` instead.
   *
   * This method doesn't expect any request body.
   */
  containertypesV2ControllerEnumDummyEndpoint$Response(
    params: {
      containertypeConfigEnum: WorkContainertypeConfigEnum;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContainertypesV2Service.ContainertypesV2ControllerEnumDummyEndpointPath, 'get');
    if (params) {
      rb.path('containertypeConfigEnum', params.containertypeConfigEnum, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `containertypesV2ControllerEnumDummyEndpoint$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  containertypesV2ControllerEnumDummyEndpoint(
    params: {
      containertypeConfigEnum: WorkContainertypeConfigEnum;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.containertypesV2ControllerEnumDummyEndpoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `containertypesV2ControllerProjectAdvisorSourceEnumDummyEndpoint()` */
  static readonly ContainertypesV2ControllerProjectAdvisorSourceEnumDummyEndpointPath = '/v2/containertypes/enum-project-advisor-source/{projectAdvisorSource}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `containertypesV2ControllerProjectAdvisorSourceEnumDummyEndpoint()` instead.
   *
   * This method doesn't expect any request body.
   */
  containertypesV2ControllerProjectAdvisorSourceEnumDummyEndpoint$Response(
    params: {
      projectAdvisorSource: WorkProjectAdvisorSourceEnum;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContainertypesV2Service.ContainertypesV2ControllerProjectAdvisorSourceEnumDummyEndpointPath, 'get');
    if (params) {
      rb.path('projectAdvisorSource', params.projectAdvisorSource, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `containertypesV2ControllerProjectAdvisorSourceEnumDummyEndpoint$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  containertypesV2ControllerProjectAdvisorSourceEnumDummyEndpoint(
    params: {
      projectAdvisorSource: WorkProjectAdvisorSourceEnum;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.containertypesV2ControllerProjectAdvisorSourceEnumDummyEndpoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
